import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { Helmet } from "react-helmet";
import AppRoutes from "./routing/app-routes";
import Layout from "./routing/Layout";
import { useAgencyInfo } from "./context/agency";

function App() {
  const [agency] = useAgencyInfo();
  const routes = AppRoutes();
  // const [agency] = useAgencyInfo();

  console.log(agency,'agency')

  const getRoutes = (allRoutes) => {
    return allRoutes.map((route) => {
      if (route.path) {
        return (
          <Route
            key={route.path}
            path={route.path}
            element={
              route?.layout === "blank" ? (
                route.element
              ) : (
                <Layout>{route.element}</Layout>
              )
            }
          />
        );
      }

      return null;
    });
  };
  return (
    <div>
      <Helmet key={"meta-description"}>
      <title>{agency?.theme_id?.theme_data?.general?.home_m_title}</title>
        <meta
          name="description"
          content={agency?.theme_id?.theme_data?.general?.home_m_description}
        />
      </Helmet>
      <Routes>
        {/* <Route path="*" element={<Navigate to="/analatics" />} /> */}
        {getRoutes(routes)}
      </Routes>
      <Toaster />
    </div>
  );
}

export default App;
